module.exports = __webpack_public_path__ + "static/media/qrcode.00143a54.png";